import React, { useState, MouseEvent } from 'react';
import { Box, Menu, MenuItem, ClickAwayListener } from '@mui/material';
import { StyledTag } from '../../AgenticMatching/StyledTag';

interface TagProps {
  label: string;
  onDelete?: () => void;
  options?: string[];
  onSelect?: (option: string) => void;
  isInteractive?: boolean;
  disabled?: boolean;
}

export default function Tag({
  label,
  onDelete,
  options = [],
  onSelect,
  isInteractive = false,
  disabled = false
}: TagProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (isInteractive) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionSelect = (option: string) => {
    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(option);
    }
    handleClose();
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box>
        <Box
          onClick={handleClick}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: isInteractive && !disabled ? 'pointer' : 'default',
            '&:hover': {
              '& .MuiBox-root': {
                backgroundColor: isInteractive && !disabled ? '#E3F2FDDD' : '#E3F2FD'
              }
            }
          }}
        >
          <StyledTag
            label={label}
            onDelete={onDelete}
            disabled={disabled}
            showArrow={isInteractive}
            isOpen={open}
          />
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              onClick={() => handleOptionSelect(option)}
              sx={{
                fontSize: '0.875rem',
                padding: '8px 16px'
              }}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </ClickAwayListener>
  );
}
